<template>
  <div class="dwt-wrapper max-w-xl mx-auto">
    <div class="dwt-container" :style="{ width, height, position: 'relative' }">
      <!-- Hidden file inputs for camera and gallery -->
      <input type="file" ref="fileInput" accept="image/*" style="display: none" @change="onFileChange" />
      <input type="file" ref="cameraInput" accept="image/*" capture="environment" style="display: none" @change="onFileChange" />
      
      <!-- Image container for Cropper.js -->
      <div v-show="imageSrc" style="width: 100%; height: 100%;">
        <img ref="image" :src="imageSrc" style="display: block; max-width: 100%;" />
      </div>

      <!-- Loading overlay -->
      <div v-if="loading" class="loading-overlay">
        <span>Cargando...</span>
      </div>
    </div>
  </div>
</template>

<script>
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  name: 'DWTCaptureImage',
  props: {
    width: { type: String, default: '350px' },
    height: { type: String, default: '250px' },
    complete: { type: Boolean, default: false },
    resourcesPath: { type: String, default: null }
  },
  data() {
    return {
      imageSrc: null,
      cropper: null,
      loading: false,
      isCropActive: false,
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
  },
  watch: {
    complete(value) {
      this.loading = value;
    }
  },
  mounted() {
    this.$emit('register-event');
  },
  beforeDestroy() {
    this.close();
  },
  methods: {
    openWindow() {
      if (this.isMobile) {
        this.showCamera();
      } else {
        this.loadImage();
      }
    },
    loadImage() {
      this.$refs.fileInput.click();
    },
    showCamera() {
      this.$refs.cameraInput.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      
      this.loading = true;
      const reader = new FileReader();
      reader.onload = (event) => {
        this.imageSrc = event.target.result;
        this.initCropper();
        this.changeEditorMode(true);
        this.$emit('change-image', true);
        this.loading = false;
      };
      reader.onerror = () => {
        this.$emit('load-error');
        this.loading = false;
      };
      reader.readAsDataURL(file);
      
      // Reset inputs
      this.$refs.fileInput.value = '';
      this.$refs.cameraInput.value = '';
    },
    initCropper() {
      if (this.cropper) {
        this.cropper.destroy();
      }
      this.$nextTick(() => {
        this.cropper = new Cropper(this.$refs.image, {
          viewMode: 1,
          dragMode: 'move',
          background: true,
          autoCrop: false,
          ready: () => {
            this.cropper.clear();
          }
        });
      });
    },
    activeCropTool() {
      if (this.cropper) {
        this.cropper.setDragMode('crop');
        this.cropper.crop();
        this.isCropActive = true;
      }
    },
    rotate() {
      if (this.cropper) {
        this.cropper.rotate(90);
      }
    },
    mirror() {
      if (this.cropper) {
        const scaleX = this.cropper.getData().scaleX || 1;
        this.cropper.scaleX(-scaleX);
      }
    },
    toSave() {
      if (!this.cropper) return;
      this.loading = true;
      
      this.cropper.getCroppedCanvas().toBlob((blob) => {
        this.$emit('save-image', { result: blob, indices: [0], type: 'IT_PNG' });
        this.loading = false;
      }, 'image/png');
    },
    close() {
      if (this.cropper) {
        this.cropper.destroy();
        this.cropper = null;
      }
      this.imageSrc = null;
      this.changeEditorMode(false);
      this.$emit('change-image', false);
    },
    changeEditorMode(value) {
      this.$emit('change-editormode', value);
    }
  }
}
</script>

<style scoped>
.dwt-wrapper {
  padding: 1rem;
  position: relative;
}
.dwt-container {
  background-color: #777;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.loading-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
</style>